import { useEffect, useState } from "react";
import { Form } from "../../common/Form";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { CommonDialog } from "../../common/CommonDialog";
import { jwordBorderThicknessOptions,jwordBorderAppRangeOptions,colorList} from "./jword-config";
import { useTranslation } from "react-i18next";

export function BorderDialog({borderProps,visible,onOK,onCancel})
{    
    const {t} = useTranslation();        
    const [borderInfo,setBorderInfo]=useState({tableMode:false});

    const onChange=(formData)=>{        
        setBorderInfo(formData);
    };
    const _onCancel=()=>{
        onCancel();
    };
    const _onOK=()=>{
        onOK(borderInfo);
    };
    const appRangeOptions=()=>{
        return jwordBorderAppRangeOptions.map((opt)=>{return {label:t('Editor.appRange.'+opt),value:opt}});
    }
    useEffect(()=>{
        console.log("borderProps:"+JSON.stringify(borderProps));
        setBorderInfo({...borderProps});
    },[borderProps]);
    return(
        <>
        <CommonDialog header={t('Editor.Borders_shading')} visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <div className="p-2" style={{maxWidth:'400px'}}>
            <Form id="formatBorder" formData={borderInfo} columns="1" onChange={onChange}
                fields={[
                    {id:"thickness",ftype:"dropdown",field:"thickness",label:t('Editor.Thickness'),options:jwordBorderThicknessOptions},
                    {id:"borderColor",ftype:"color",field:"borderColor",label:t('Editor.Border_Color'),options:colorList},                    
                    {id:"backColor",ftype:"color",field:"backColor",label:t('Editor.Background_Color'),options:colorList},
                    {id:"appRange",ftype:"dropdown",field:"appRange",label:t('Editor.Apply_To'),options:appRangeOptions(),disabled:!borderProps.tableMode}
                ]}>
            </Form>	
            </div>
        </CommonDialog>
        </>
    );
}